import { FacilityGroupAssignedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/facility_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type FacilityGroupAssignedDetailProps = {
  event: FacilityGroupAssignedEvent;
};

export const FacilityGroupAssignedDetail = ({
  event,
}: FacilityGroupAssignedDetailProps) => {
  const facility = event.facility;

  if (!facility) {
    return (
      <Col className="@FacilityGroupAssignedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@FacilityGroupAssignedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Facility Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={facility.id?.value} />
          <FieldDisplay label="Name" value={facility.facilityName} />
          <FieldDisplay label="Type" value={facility.facilityType} />
        </div>
      </Col>

      <Col
        className="rounded-md border border-success/20 bg-success/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-success/80">
          Group Assignment
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField
            label="Assigned Facility Group ID"
            value={event.facilityGroupId?.value}
          />
        </div>
      </Col>
    </Col>
  );
};
